'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base2 = require('./Base');

var _Base3 = _interopRequireDefault(_Base2);

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/hls.js/latest/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/2.5.0/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';

var FilePlayer = function (_Base) {
  _inherits(FilePlayer, _Base);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.renderSource = function (source) {
      if (typeof source === 'string') {
        return _react2['default'].createElement('source', { key: source, src: source });
      }
      var src = source.src,
          type = source.type;

      return _react2['default'].createElement('source', { key: src, src: src, type: type });
    }, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          playsinline = _props.playsinline,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError;

      this.player.addEventListener('canplay', this.onReady);
      this.player.addEventListener('play', this.onPlay);
      this.player.addEventListener('pause', function () {
        if (_this2.mounted) {
          onPause();
        }
      });
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      if (playsinline) {
        this.player.setAttribute('playsinline', '');
        this.player.setAttribute('webkit-playsinline', '');
      }
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError;

      this.player.removeEventListener('canplay', this.onReady);
      this.player.removeEventListener('play', this.onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'shouldUseHLS',
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) || this.props.fileConfig.forceHLS;
    }
  }, {
    key: 'shouldUseDASH',
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.fileConfig.forceDASH;
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this3 = this;

      if (this.shouldUseHLS(url)) {
        loadSDK(HLS_SDK_URL, HLS_GLOBAL).then(function (Hls) {
          _this3.hls = new Hls();
          _this3.hls.loadSource(url);
          _this3.hls.attachMedia(_this3.player);
        });
      }
      if (this.shouldUseDASH(url)) {
        loadSDK(DASH_SDK_URL, DASH_GLOBAL).then(function (dashjs) {
          var player = dashjs.MediaPlayer().create();
          player.initialize(_this3.player, url, true);
        });
      }
    }
  }, {
    key: 'play',
    value: function play() {
      this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
      if (this.hls) {
        this.hls.detachMedia();
      }
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      if (fraction === 1) {
        this.pause();
      }
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
      this.player.currentTime = this.getDuration() * fraction;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady) return null;
      return this.player.currentTime / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || this.player.buffered.length === 0) return null;
      return this.player.buffered.end(0) / this.getDuration();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          loop = _props3.loop,
          controls = _props3.controls,
          fileConfig = _props3.fileConfig,
          width = _props3.width,
          height = _props3.height;

      var useAudio = AUDIO_EXTENSIONS.test(url) || fileConfig.forceAudio;
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      var Element = useAudio ? 'audio' : 'video';
      var src = url instanceof Array || useHLS || useDASH ? undefined : url;
      var style = {
        width: !width || width === 'auto' ? width : '100%',
        height: !height || height === 'auto' ? height : '100%',
        display: url ? 'block' : 'none'
      };
      return _react2['default'].createElement(
        Element,
        _extends({
          ref: this.ref,
          src: src,
          style: style,
          preload: 'auto',
          controls: controls,
          loop: loop
        }, fileConfig.attributes),
        url instanceof Array && url.map(this.renderSource)
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return true;
    }
  }]);

  return FilePlayer;
}(_Base3['default']);

FilePlayer.displayName = 'FilePlayer';
exports['default'] = FilePlayer;


function loadSDK(url, globalVar) {
  if (window[globalVar]) {
    return Promise.resolve(window[globalVar]);
  }
  return new Promise(function (resolve, reject) {
    (0, _loadScript2['default'])(url, function (err) {
      if (err) reject(err);
      resolve(window[globalVar]);
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/react-player/lib/players/FilePlayer.js
// module id = 49
// module chunks = 0